module.exports = __webpack_public_path__ + "media/images/bg-pattern-light-d2ae4bbe176c9234f0f18d0050e43b6b.svg";